import type { EstadoCaso } from "@/lib/api";

// Colores de los estados del CASO. Fuente ÚNICA: Casos, Panel, CasoDetalle y
// PanelHilo importan de aquí (tenían su propia copia y había que tocar cinco
// archivos para agregar un estado).
export const ESTADO_CASO_PILL: Record<EstadoCaso, string> = {
  "Abierto": "bg-amber-500/10 text-amber-300 border-amber-500/30",
  "En revision": "bg-amber-500/10 text-amber-300 border-amber-500/30",
  // Violeta: está con nosotros (ámbar) pero ya de salida (cian). Se distingue a
  // propósito, es el estado que antes se confundía con "En revision".
  "Listo para enviar": "bg-violet-500/10 text-violet-300 border-violet-500/30",
  "Enviado al proveedor": "bg-cyan-500/10 text-cyan-300 border-cyan-500/30",
  "Esperando proveedor": "bg-cyan-500/10 text-cyan-300 border-cyan-500/30",
  "Pendiente cliente": "bg-sky-500/10 text-sky-300 border-sky-500/30",
  "Cerrado": "bg-emerald-500/10 text-emerald-300 border-emerald-500/30",
};

// Estados del caso que se pueden fijar desde la bitácora cuando el caso NO tiene
// IMEIs (consultas/dudas). "Cerrado" tiene su propio botón.
export const ESTADOS_CASO_BITACORA: EstadoCaso[] = [
  "Abierto",
  "En revision",
  "Listo para enviar",
  "Enviado al proveedor",
  "Esperando proveedor",
  "Pendiente cliente",
];
